module.exports = __webpack_public_path__ + "img/car_0008.c7e5020b.jpg";